<template>
  <div>
    <ticket-filter @change="onChange" />
    <br />
    <ticket-create :filter-form="filterForm" :user-list="userData" :tag-list="problemTags" />
    <br />
    <ticket-tag-per :filter-form="filterForm" :user-list="userData" :tag-list="problemTags" />
    <br />
    <ticket-solve-time :filter-form="filterForm" />
    <br />
    <ticket-create-time :filter-form="filterForm" />

  </div>
</template>
<script>
import TicketFilter from '@/pages/data/ticket/components/TicketFilter';
import TicketSolveTime from '@/pages/data/ticket/components/TicketSolveTime';
import TicketCreate from '@/pages/data/ticket/components/TicketCreate';
import TicketTagPer from '@/pages/data/ticket/components/TicketTagPer';
import TicketCreateTime from '@/pages/data/ticket/components/TicketCreateTime';
import { userList } from '@/api/system/auth';
import { ticketTags } from '@/api/event/problem';

export default {
  components: { TicketFilter, TicketCreate, TicketTagPer, TicketCreateTime, TicketSolveTime },
  data() {
    return {
      problemTags: [],
      userData: [],
      filterForm: {
        begin_date: null,
        end_date: null
      }
    };
  },
  mounted() {
    this.getUserList();
    this.getTicketTags();
  },
  methods: {
    onChange(checkedDate, checkedTeams) {
      this.filterForm = {
        begin_date: checkedDate[0].format('YYYY-MM-DD'),
        end_date: checkedDate[1].format('YYYY-MM-DD'),
        refers: checkedTeams
      };
    },
    getTicketTags() {
      ticketTags({}).then(res => {
        this.problemTags = res.data.items;
      });
    },
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users;
      });
    }
  }
};
</script>

